import { __decorate, __extends } from "tslib";
import { Component, Prop, Vue } from 'vue-property-decorator';

var LayoutBrand =
/** @class */
function (_super) {
  __extends(LayoutBrand, _super);

  function LayoutBrand() {
    return _super !== null && _super.apply(this, arguments) || this;
  }

  LayoutBrand.prototype.onClick = function () {
    location.href = 'https://www.qizengzhang.cn';
  };

  __decorate([Prop({
    type: Boolean
  })], LayoutBrand.prototype, "tabbar", void 0);

  LayoutBrand = __decorate([Component({
    name: 'LayoutBrand'
  })], LayoutBrand);
  return LayoutBrand;
}(Vue);

export default LayoutBrand;